import { GET_LEDGER_REPORT } from "../actions/types";

const initialState = {
  ledgerReportData: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_LEDGER_REPORT:
      return {
        ...state,
        ledgerReportData: action.payload.data || [], 
      };
    default:
      return state;
  }
}